import React from 'react';
import AppLayout from "../components/AppLayout";

function TestPage() {
  return (
    <AppLayout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Test Page</h1>
        <p>This is a test page to check if AppLayout works.</p>
        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-lg font-semibold">Test Content</h2>
          <p>If you can see this page with a sidebar, AppLayout is working.</p>
        </div>
      </div>
    </AppLayout>
  );
}

export default TestPage; 